export default __webpack_public_path__ + "static/media/car2.566a720e.jpg";